import axios from "axios";
import { useEffect } from "react";
import { useState } from "react";

const useAboutUs = () => {
  const [aboutUs, setAboutUs] = useState([]);
  const [loading, setLoading] = useState(false);

  const rupali_api_url = process.env.REACT_APP_RUPALI_API_HOST;

  const url = `${rupali_api_url}/Api/WebSite/AboutUs`;

  useEffect(() => {
    axios.get(url).then((res) => {
      setAboutUs(res.data.data);
      setLoading(true);
    });
  }, []);

  return [aboutUs, setAboutUs, loading];
};

export default useAboutUs;
